import React from 'react';
import { Link } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { useHits } from 'react-instantsearch';
import { Button, Card, Grid } from '@printdeal/ui-library';
import type { BaseHit } from 'instantsearch.js';
import { Image } from '@unpic/react';

interface Props extends BaseHit {
  objectID: string;
  productName: string;
  name: string;
  slug: string;
  featuredDescription: string;
  path: string;
  image: {
    src: string;
  };
}

export const FacetFilteringProducts = () => {
  const { results } = useHits<Props>();

  if (results && !results.hits) return null;

  return (
    <Grid.Item>
      <Grid className="pd-grid-cols-1 pd-gap-4 sm:pd-grid-cols-2 md:pd-grid-cols-4">
        {results?.hits.map((hit) => (
          <Grid.Item key={hit.objectID}>
            <Card
              className="pd-h-full"
              data-cy="productCard"
              link={<Link to={hit.path} />}
              title={hit.productName}
              image={hit.image?.src ? (
                <Image
                  layout="constrained"
                  src={hit.image?.src}
                  aspectRatio={1}
                  alt={hit.name}
                  breakpoints={[260, 315, 360]}
                  width={360}
                  cdn="contentful"
                />
              ) : undefined}
            >
              <p>
                {hit.featuredDescription}
              </p>
              <footer className="pd-mt-auto pd-w-full">
                <Button
                  as="span"
                  className="pd-hidden md:pd-flex"
                  variant="secondary"
                >
                  <FormattedMessage id="general.compose" defaultMessage="Compose" />
                </Button>
              </footer>
            </Card>
          </Grid.Item>
        ))}
      </Grid>
    </Grid.Item>
  );
};
